import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../components/ToastComponent/store/toastMiddleware';
import { type AppDispatch } from '../../../redux/store';
import {
  createNewSale,
  getSaleTypes,
  searchSaleNumbers,
  getSaleBySaleNumber,
  getUnpledgedSales,
  getUndisbursedSales,
  updateUndisbursedSale,
  getUnapprovedSales,
  updateUnapprovedSale,
  searchClosedSaleNumbers,
  getUnsettledSalePayments,
  updateUnsettledSalePayment,
  updateSalePaymentSplit,
  getUnapprovedSalePayments,
  updateSalePrincipal,
  createSalePayment
} from './salesMiddleware';
import { type CreateSaleRequest, type SalePaymentRequest } from './salesTypes';

export const createNewSaleAction = async (
  dispatch: AppDispatch,
  payload: CreateSaleRequest
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(createNewSale(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Sale Created Successfully'));
    return res.payload.sale;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error creating sale'));
    return false;
  }
};

export const getSaleTypesAction = async (
  dispatch: AppDispatch
) => {
  const res = await dispatch(getSaleTypes({}));
  console.log('res.data', res);
};

export const searchSaleNumbersAction = async (
  dispatch: AppDispatch,
  payload: string
) => {
  const res: any = await dispatch(searchSaleNumbers(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching sale numbers'));
    return false;
  }
};

export const searchClosedSaleNumbersAction = async (
  dispatch: AppDispatch,
  payload: string
) => {
  const res: any = await dispatch(searchClosedSaleNumbers(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching sale numbers'));
    return false;
  }
};

export const getSaleBySaleNumberAction = async (
  dispatch: AppDispatch,
  payload: string
) => {
  const res: any = await dispatch(getSaleBySaleNumber(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error fetching sale numbers'));
    return false;
  }
};

export const getUnpledgedSalesAction = async (
  dispatch: AppDispatch,
  payload: { branch: string}
) => {
  const res = await dispatch(getUnpledgedSales(payload));
  console.log(res);
};

export const getUndisbursedSalesAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getUndisbursedSales(null));
  console.log(res);
};

export const updateUndisbursedSaleAction = async (
  dispatch: AppDispatch,
  payload: {id: string}
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updateUndisbursedSale(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Sale updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating sale'));
    return false;
  }
};

export const getUnsettledSalePaymentsAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getUnsettledSalePayments(null));
  console.log(res);
};

export const getUnapprovedSalePaymentsAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getUnapprovedSalePayments(null));
  console.log(res);
};

export const updateUnsettledSalePaymentsAction = async (
  dispatch: AppDispatch,
  payload: {id: string, status: string}
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updateUnsettledSalePayment(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Sale payment updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating sale payment'));
    return false;
  }
};

export const updateSalePaymentSplitAction = async (
  dispatch: AppDispatch,
  payload: { id: string; onlinePrincipal: number; offlinePrincipal: number }
) => {
  const res: any = await dispatch(updateSalePaymentSplit(payload));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Payment amounts updated Successfully'));
  } else {
    dispatch(
      showErrorMessage(
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        res.payload?.response?.data?.message || 'Error updating payment amounts'
      )
    );
    return false;
  }
};

export const getUnapprovedSalesAction = async (
  dispatch: AppDispatch,
  payload: any
) => {
  const res = await dispatch(getUnapprovedSales(null));
  console.log(res);
};

export const updateUnapprovedSaleAction = async (
  dispatch: AppDispatch,
  payload: {id: string, status: string}
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updateUnapprovedSale(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Sale updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating sale'));
    return false;
  }
};

export const updateSalePrincipalAction = async (dispatch: any, payload: { id: string; onlinePrincipal?: number; offlinePrincipal?: number }) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(updateSalePrincipal(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Sale principal updated Successfully'));
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error updating sale principal'));
    return false;
  }
};

export const createSalePaymentAction = async (
  dispatch: AppDispatch,
  payload: SalePaymentRequest
) => {
  const data = {
    ...payload,
  };
  const res: any = await dispatch(createSalePayment(data));

  if (res.meta.requestStatus === 'fulfilled') {
    dispatch(showSuccessMessage('Sale Payment Created Successfully'));
    return res.payload;
  } else {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    dispatch(showErrorMessage(res.payload?.response?.data?.message || 'Error creating sale payment'));
    return false;
  }
};
